import { Box, BoxProps, EmptyView, Loader } from '@jfs/ui-new'

interface ContainerProps extends BoxProps {
  children?: any
  isLoading?: any
  errorMessage?: string
  emptyMessage?: string
  onRetry?: any
  paddingTop?: any
  show?: boolean
}

export const Container = ({
  children,
  isLoading,
  errorMessage,
  emptyMessage,
  onRetry,
  show = true,
  paddingTop = 0,
  ...props
}: ContainerProps) => {
  if (!show) {
    return null
  }
  const shouldShowEmptyView = () => isLoading || errorMessage || emptyMessage
  return (
    <Box width={'100%'} height={'100%'} paddingTop={paddingTop} {...props}>
      {shouldShowEmptyView() && (
        <Box height={'100%'} justifyContent={'center'}>
          <EmptyView
            onRetry={onRetry}
            isLoading={isLoading}
            loaderComponent={<Loader type="large" color="PRIMARY" />}
            emptyMessage={emptyMessage}
            error={errorMessage && { networkError: { data: { errors: [{ details: errorMessage }] } } }}
          />
        </Box>
      )}
      {!shouldShowEmptyView() && children}
    </Box>
  )
}
